const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://yqvmj6du97.execute-api.us-west-2.amazonaws.com/prod',
    COMPANY_API_URL: 'https://5ub4e928t8.execute-api.us-west-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'taxonomy-company-1.13.4',
    HOSTNAME: 'https://company.staging.valeglobal.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.staging.valeglobal.forwoodsafety.com',
    WEBSOCKET: 'wss://fjbp8skumh.execute-api.us-west-2.amazonaws.com/staging'
  },
};

export default config;